import React from 'react';

import Button from '~/components/button';
import { Field, Form } from '~/components/form';
import InputField from '~/components/inputs/input-field';
import IntroText from '~/components/lawns/new/lawn-size-components/intro-text';
import SizeGuideAccordion from '~/components/lawns/new/lawn-size-components/size-guide-accordion';
import { formatNumber } from '~/utils/numbers';
import { number, required, valid } from '~/utils/validation';

import styles from '~/components/lawns/lawns.module.scss';

const TextInput = ({
  lawn,
  onContinue,
  onSomethingsNotRight,
  isSubmitting,
}) => {
  return (
    <div className={styles.textInputVariantContainer}>
      <IntroText />
      <h2 className={styles.estimatedSizeTitle}>Estimated yard size</h2>
      <p className={styles.estimatedSize}>
        {formatNumber(lawn.size.sqFt)} sq. ft
      </p>
      <p>{lawn.address.line1}</p>
      <p>
        {lawn.address.city}, {lawn.address.stateCode} {lawn.address.postalCode}
      </p>
      <Form
        className={styles.textInputSizeForm}
        onSubmit={(formValues) => onContinue(formValues.lawnSize)}
        initialValues={{
          lawnSize: lawn?.size.sqFt,
        }}
        validate={(formValues) => {
          return {
            lawnSize: valid(
              required(' '), // Intentional space so that we DON'T use the default error message (the red label is enough for this use case)
              number('Please enter a number (without any commas, please)')
            )(formValues.lawnSize),
          };
        }}
      >
        {() => (
          <>
            <Field
              label={
                <span className={styles.label}>
                  Edit the area of lawn you want treated (in sq. ft)
                </span>
              }
              placeholder="lawn size (sq. ft)"
              name="lawnSize"
              component={InputField}
              rows={4}
            />
            <SizeGuideAccordion />
            <div className={styles.desktopOnly}>
              <Button type="submit" fullWidth isLoading={isSubmitting}>
                Continue
              </Button>
              <div className={styles.somethingsNotRightButtonContainer}>
                <Button
                  onClick={onSomethingsNotRight}
                  type="button"
                  variant="outline"
                  fullWidth
                >
                  Something's not right
                </Button>
              </div>
            </div>
            <div className={styles.floatingButtonWrapper}>
              <Button
                onClick={onSomethingsNotRight}
                type="button"
                variant="link"
              >
                Something's off
              </Button>
              <Button type="submit" isLoading={isSubmitting} variant="yellow">
                Continue
              </Button>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};

export default TextInput;
